import { render, staticRenderFns } from "./StockOverview.vue?vue&type=template&id=15eadcd0&scoped=true&"
import script from "./StockOverview.vue?vue&type=script&lang=js&"
export * from "./StockOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eadcd0",
  null
  
)

export default component.exports